 // Product media video auto paly code start 
 $(document).ready(function() {
   $('.product-gallery__media video-media').trigger("click");
  });
  // Product media video auto paly code end
jQuery(document).ready(function(){
  
jQuery(document).on('change','.product-card .var_form .dev_var input[type="radio"]',function(){
        var value=jQuery(this).val();
        var price=jQuery(this).attr('data-price');
        var compare_price=jQuery(this).attr('data-compare');
        var badge=jQuery(this).attr('data-badge');
        var btn_available=jQuery(this).attr('data-available');  
          if(btn_available == "true")
          {
            jQuery(this).closest('.product-card').find('.dev_atc_btn').addClass("available_btn")
            jQuery(this).closest('.product-card').find('.dev_sold_btn').removeClass("available_btn")
          }
          else
          {
            jQuery(this).closest('.product-card').find('.dev_atc_btn').removeClass("available_btn")
            jQuery(this).closest('.product-card').find('.dev_sold_btn').addClass("available_btn")
            }
        jQuery(this).closest('.product-card').find('.shopify-product-form input[name="id"]').attr('value',value);
         jQuery(this).closest('.product-card').find('.dev_custom_price').text(price);
         jQuery(this).closest('.product-card').find('.var_form label').removeClass('active');
          jQuery(this).closest('.product-card').find('.dev_badge').hide();
        jQuery(this).closest('.product-card').find('.dev_compare_price').text('');
         jQuery(this).closest('label').addClass('active');
          if(compare_price !== "")
          {
            jQuery(this).closest('.product-card').find('.dev_badge').show();
          jQuery(this).closest('.product-card').find('.dev_compare_price').text(compare_price);            
            jQuery(this).closest('.product-card').find('.dev_badge').text("SAVE "+badge);
          }
         
         
      })
})


// //Customize  Products page offer code copy  Start
document.addEventListener('click', function(event) {
    if (event.target.classList.contains('ct-offer-code-button-svg')) {
        var thisParent = event.target.closest('.ct_gift_1, .ct_gift_2, .ct_gift_3');
        var code_Poff = thisParent.querySelector(".ct-offer-copyed");
        var class_q = thisParent.querySelector('.ct-offer-code').innerHTML;
        
        document.execCommand("copy");
        code_Poff.style.display = "block";
        setTimeout(function() {
            code_Poff.style.display = "none";
        }, 3000);
        
        navigator.clipboard.writeText(class_q);
      
    } else if (event.target.classList.contains('ct-cart-copy-code')) {
        var parent = event.target.closest('.ct_gift_1, .ct_gift_2, .ct_gift_3');
        var code_Poff = parent.querySelector(".ct-pro-offer-copyed");
        var class_q = parent.querySelector('.ct-cart-offer-code').innerHTML;
        
        document.execCommand("copy");
        code_Poff.style.display = "block";
        setTimeout(function() {
            code_Poff.style.display = "none";
        }, 3000);
        
        navigator.clipboard.writeText(class_q);
    }
});
// //Customize  Products page offer code copy  End


  
  // // Products page offer code copy strat Meta
  var code_pro = document.querySelector(".ct-pro-offer-btn");
  if(code_pro != null){
    var code_Poff =  document.querySelector('.ct-pro-offer-copyed');
    code_pro.onclick = function() {
      document.execCommand("copy");
      code_Poff.style.display="block"; 
      setTimeout(function(){
        code_Poff.style.display="none";
      }, 3000); 
    }
    code_pro.addEventListener("click", function() {
        var class_q = document.querySelector('#ct_col_offcode').innerHTML;
        navigator.clipboard.writeText(class_q);
    });
  }
  
var code_pro2 = document.querySelector("#ct-pro-offer-btn2");
if(code_pro2 != null){
    var code_Poff2 =  document.querySelector('.ct-pro-offer-copyed.copyed-2');
    code_pro2.onclick = function() {
      document.execCommand("copy");
      code_Poff2.style.display="block"; 
      setTimeout(function(){
        code_Poff2.style.display="none";
      }, 3000); 
    }
    code_pro2.addEventListener("click", function() {
      var class_q2 = document.querySelector('#ct_col_offcode2').innerHTML;
        navigator.clipboard.writeText(class_q2);
    });
}
  
var code_pro3 = document.querySelector("#ct-pro-offer-btn3");
if(code_pro3 != null){
  var code_Poff3 =  document.querySelector('.ct-pro-offer-copyed.copyed-3');
  code_pro3.onclick = function() {
    document.execCommand("copy");
    code_Poff3.style.display="block"; 
    setTimeout(function(){
      code_Poff3.style.display="none";
    }, 3000); 
  }
  code_pro3.addEventListener("click", function() {
    var class_q3 = document.querySelector('#ct_col_offcode3').innerHTML;
      navigator.clipboard.writeText(class_q3);
  });
}
  
// // Products page offer code copy end



// var h3height = 0;
// $('.ct-new-arrival .v-stack_main').each(function() {
//     if(h3height < $(this).outerHeight()){
//         h3height = $(this).outerHeight();
//     };
// });
// $('.ct-new-arrival .v-stack_main').height(h3height);

